module.exports = __webpack_public_path__ + "media/successScan.35fef3c0.mp3";